/**
 * Format field labels for display in charts and UI
 * Converts "table_name.field_name" to "Field Name"
 */
export function formatFieldLabel(fullFieldName: string): string {
    if (!fullFieldName) return '';

    // Strip table prefix (everything before last dot)
    const fieldName = fullFieldName.split('.').pop() || fullFieldName;

    // Replace underscores with spaces
    let formatted = fieldName.replace(/_/g, ' ');

    // Capitalize each word
    formatted = formatted
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');

    // Truncate if too long
    if (formatted.length > 25) {
        formatted = formatted.substring(0, 22) + '...';
    }

    return formatted;
}

/**
 * Get short label for Y-series display
 * Example: "Sum of Revenue" instead of "sales_data.total_revenue"
 */
export function formatSeriesLabel(field: string, aggregation: string): string {
    const fieldLabel = formatFieldLabel(field);

    const aggMap: Record<string, string> = {
        sum: 'Sum',
        avg: 'Avg',
        min: 'Min',
        max: 'Max',
        count: 'Count'
    };

    const aggLabel = aggMap[aggregation] || aggregation;

    return `${aggLabel} of ${fieldLabel}`;
}
